export const IGNORE_PINNED_MENU_LIST = [
    'FREIGHT_FORWARDING_IC_SEARCH',
    'FREIGHT_FORWARDING_AI_SEARCH',
    'EDM_MULTI_ACCOUNT_INFO',
    'TRAFFIC_PLACEMENT',
];
export const ADMIN_PINNED_MENU_LIST = [];
export const ULTIMATE_VERSION_AND_ADMIN_MENU_LIST = [];
